<template>
    <div class="container intro">
        <div class="intro__list">
                <swiper
                    :spaceBetween="30"
                    :centeredSlides="true"
                    :autoplay="{
                        delay: 2500,
                        disableOnInteraction: false,
                    }"
                    :pagination="{
                        clickable: true,
                    }"
                    :modules="modules"
                    class="mySwiper intro__list-one">
                    <swiper-slide>
                        <img src="../../assets/img/arko-mebel-intro-img3.jpg" alt="">
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../../assets/img/arko-mebel-intro-img.jpg" alt="">
                    </swiper-slide>
                    <swiper-slide>
                        <img src="../../assets/img/muddatli_tolov1.jpg" alt="">
                    </swiper-slide>
                </swiper>
            <div class="intro__list-two"></div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';

import { Autoplay, Pagination, Navigation } from "swiper";
export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Autoplay, Pagination, Navigation],
        };
    },
}

</script>
<style lang="">
    
</style>